function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.32,10H6a2.5,2.5,0,0,0-2.5,2.5v7A2.5,2.5,0,0,0,6,22H25.32a2.5,2.5,0,0,0,2.5-2.5v-7A2.5,2.5,0,0,0,25.32,10Zm1,9.54a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1H25.32a1,1,0,0,1,1,1Zm4.45-2.8a2.12,2.12,0,0,1-1.53,1.53V14.11A2.14,2.14,0,0,1,30.77,16.72ZM11.49,14v4.17a1,1,0,0,1-1,1H7.9a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h2.59A1,1,0,0,1,11.49,14Zm13,0v4.17a1,1,0,0,1-1,1H20.9a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h2.59A1,1,0,0,1,24.49,14ZM18,14v4.17a1,1,0,0,1-1,1H14.4a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H17A1,1,0,0,1,18,14Z",
  fill: "#33ba69"
});

var SvgBatteryLevelFullIcon = function SvgBatteryLevelFullIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBatteryLevelFullIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/battery_level_full_icon.f740a2fc.svg";
export { ForwardRef as ReactComponent };